"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TextArea = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _styles = require("@material-ui/core/styles");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _TextField = _interopRequireDefault(require("../TextField"));
var _excluded = ["classes", "dataMetrics", "width"],
  _excluded2 = ["InputProps", "rows", "rowsMin", "style"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var styles = function styles() {
  return {
    inputMultiline: {
      minHeight: '20px'
    }
  };
};
var defaultProps = {
  classes: {},
  dataMetrics: {
    root: 'fuse_text_area'
  },
  rows: 3
};

/**
 * Text areas are taller than text fields and wrap overflow text onto a new line. They are a fixed height and scroll vertically when the cursor reaches the bottom of the field.
 */
var TextArea = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var classes = _ref.classes,
    dataMetrics = _ref.dataMetrics,
    width = _ref.width,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _rest = _objectSpread({}, rest),
    _rest$InputProps = _rest.InputProps,
    InputProps = _rest$InputProps === void 0 ? {} : _rest$InputProps,
    rows = _rest.rows,
    rowsMin = _rest.rowsMin,
    style = _rest.style,
    other = (0, _objectWithoutProperties2["default"])(_rest, _excluded2);
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  return /*#__PURE__*/_react["default"].createElement(_TextField["default"], (0, _extends2["default"])({
    "data-metrics": mergedDataMetrics.root,
    InputProps: _objectSpread({
      classes: {
        inputMultiline: (0, _classnames["default"])((0, _defineProperty2["default"])({}, classes.inputMultiline, !rest.disabled || !InputProps.readOnly))
      }
    }, InputProps),
    minRows: rows || rowsMin,
    multiline: true,
    width: width,
    style: style,
    ref: ref
  }, other));
});
exports.TextArea = TextArea;
TextArea.defaultProps = defaultProps;
TextArea.displayName = 'TextArea';
TextArea.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes["default"].object,
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    root: _propTypes["default"].string
  }),
  /**
   * The default value of the `Input` element.
   */
  defaultValue: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  /**
   * If `true`, the input will be disabled.
   */
  disabled: _propTypes["default"].bool,
  /**
   * @ignore
   */
  onChange: _propTypes["default"].func,
  /**
   * Number of rows to display when multiline option is set to true.
   * **The prop rows is deprecated. Use rowsMin instead.**
   */
  rows: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  /**
   * Use that property to pass a ref callback to the native textarea element.
   */
  textareaRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
  /**
   * @ignore
   */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  /**
   * A fixed width of TextArea. Ex: 400. 450px. 50%
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
} : {};
TextArea.defaultProps = {
  rows: 3
};
var ExportComponent = (0, _styles.withStyles)(styles)(TextArea);
ExportComponent.displayName = 'TextArea';
var _default = ExportComponent;
exports["default"] = _default;